<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <div class="form-group custom-datepicker">
                <date-picker
                    v-model="model"
                    v-validate="{
                        required: field.isRequired,
                    }"
                    class="form-control"
                    format="DD/MM/YYYY"
                    lang="en"
                    :disabled="loading || isDisabled"
                    :data-vv-name="field.label"
                    :class="{
                        'is-invalid': errors.has(field.label),
                    }"
                    :end-at="endAt"
                    :start-at="startAt"
                    :default-value="disabledAfter"
                    @input="onInput"
                ></date-picker>
                <i
                    :class="[
                        {
                            'disable-input': false,
                        },
                        'icon-calendar',
                    ]"
                ></i>
            </div>
            <p v-if="note" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ note }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import DatePicker from 'vue2-datepicker'

export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        DatePicker,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data: function () {
        console.log(
            'date now: ' +
                JSON.stringify(
                    this.$store.state.registration.form.identityInfo.number
                )
        )
        if (
            this.field.key === 'basicInfo.dateOfBirth' &&
            (this.$store.state.registration.form.identityInfo.number == null ||
                this.$store.state.registration.form.identityInfo.number == '')
        ) {
            let date = new Date()
            date.setFullYear(date.getFullYear() - 18)
            this.disabledAfter = date
            return date
        }
        return {
            disabledAfter: new Date(),
            isDisabled: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         *
         * @return {string}
         */
        note() {
            return this.field.note
        }, // End of note() method
        endAt() {
            if (
                this.field.key == 'identityInfo.IssuanceDate' ||
                this.field.key == 'accountInfo.guardianIssuanceDate' ||
                this.field.key == 'accountInfo.nomineeIssuanceDate1'
            ) {
                return new Date()
            } else if (this.field.key == 'basicInfo.dateOfBirth') {
                let date = new Date()
                date.setFullYear(date.getFullYear() - 18)
                return date
            }
            return ''
        },
        startAt() {
            if (
                this.field.key == 'identityInfo.expiryDate' ||
                this.field.key == 'accountInfo.nomineeExpiryDate1' ||
                this.field.key == 'accountInfo.guardianExpiryDate'
            ) {
                return new Date()
            } else {
                return new Date('01/01/1900')
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.field.key == 'identityInfo.expiryDate') {
            if (
                this.$store.state.registration.form.identityInfo
                    .isLifetimeExpiry == 'Yes'
            ) {
                this.field.isRequired = false
                this.isDisabled = true
                this.onInput('')
            }
        }
    }, // End of Component > computed

    created() {
        if (this.field.key == 'identityInfo.expiryDate') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo
                        .isLifetimeExpiry // could also put a Getter here
                },
                (newValue, oldValue) => {
                    //something changed do something
                    //console.log(oldValue)
                    //console.log(newValue)

                    if (newValue == 'Yes') {
                        this.field.isRequired = false
                        this.isDisabled = true
                        this.onInput('')
                    } else {
                        this.field.isRequired = true
                        this.isDisabled = false
                    }
                }
            )
        }
    },

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the value is updated
         *
         * @return {void}
         */
        onInput(newValue) {
            this.model = newValue
        }, // End of onInput() method

        setAdult() {
            if (this.field.key == 'basicInfo.dateOfBirth') {
                //console.log('18 date')
                let date = new Date()
                date.setFullYear(date.getFullYear() - 18)
                return date
            } else {
                //console.log('default date')

                return new Date()
            }
            //this.model = newValue
        },
    }, // End of Component > mounted
}
</script>
